// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b5f3aa29","453":"7293cc9b","455":"28e3172b","977":"01172a94"}[chunkId] + ".chunk.js";
};